import React from 'react';

const BacktestBanner = () => {
  return (
    <div className="services-banner backtesting-banner">
      <div className="container">
        <div className="services-banner-wrapper">
          <h1>Backtesting</h1>
          <p>
            Our backtesting hub is where we Dive into the past to shape your
            future success in the markets and refine your financial strategies
            for tomorrow!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BacktestBanner;
